/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable eqeqeq */
import React from 'react';
import { Modal, Box, Grid, Typography, Button } from '@mui/material';

import useStyles from '../../../assets/styles/pages/ShopRequest';

import { ReactComponent as IconRequest } from '../../../assets/images/svg/shops/request/icon_pedido_enviar.svg';
import { ReactComponent as IconLocation } from '../../../assets/images/svg/shops/request/icon_local.svg';
import { ReactComponent as IconWallet } from '../../../assets/images/svg/shops/request/icon_carteira.svg';
import { ReactComponent as IconFidelidade0 } from '../../../assets/images/svg/menu_main/icon_fidelidade_0.svg';

import { FormatPrice } from '../../../helpers/utils/Formating';

interface Props {
  open: boolean;
  onClose: () => void;
  dataRequest: any;
  shopAddress: string;
  handleSendRequest: () => void;
  desNameBtnSend: string;
}

const styleModalBottom = {
  position: 'absolute' as const,
  bottom: 0,
  width: '100%',
  maxWidth: 680,
  borderRadius: '32px 32px 0px 0px',
  p: '20px 20px 10px 20px',
  bgcolor: 'background.paper',
  outline: 'none',
};

export const ConfirmOrderModal = ({
  open,
  onClose,
  dataRequest,
  shopAddress,
  handleSendRequest,
  desNameBtnSend,
}: Props): JSX.Element => {
  const classeStyle = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styleModalBottom}>
        <Grid container item xs={12} justifyContent="center">
          <IconRequest className={classeStyle.iconModal} />
        </Grid>

        <Grid item xs={12} justifyContent="center">
          <Typography
            variant="h6"
            component="h2"
            className={classeStyle.titleModal}
            style={{ fontWeight: '550' }}
          >
            Confirmação
          </Typography>

          <Grid className={classeStyle.gridInfoOrderConfirm}>
            {dataRequest.dsEntrega && (
              <Grid className={classeStyle.gridInfoOrderConfirmAddress}>
                <IconLocation />
                <Grid>
                  <h5 className={classeStyle.gridInfoOrderConfirmAddressText}>
                    {dataRequest.idEntrega == 1
                      ? dataRequest.dsEntrega
                      : shopAddress}
                  </h5>
                  <p className={classeStyle.gridInfoOrderConfirmTextP}>
                    {dataRequest.idEntrega == 1
                      ? 'Endereço de entrega'
                      : 'Endereço para retirada'}
                  </p>
                </Grid>
              </Grid>
            )}

            {dataRequest?.dsPagamento && (
              <Grid className={classeStyle.gridInfoOrderConfirmPayment}>
                <IconWallet />
                <Grid>
                  <h5 className={classeStyle.gridInfoOrderConfirmPaymentText}>
                    {dataRequest.flgPix == 1
                      ? `${dataRequest.dsPagamento}: ${dataRequest.dsChavePix}`
                      : dataRequest.dsPagamento}
                  </h5>
                  <p className={classeStyle.gridInfoOrderConfirmTextP}>
                    {dataRequest?.flgPix == 1 && 'Pagamento por PIX'}
                    {dataRequest?.idPagamentoForma != 2 &&
                      'Pagamento pelo aplicativo'}
                    {dataRequest?.dsTroco && dataRequest.dsTroco}
                  </p>
                </Grid>
              </Grid>
            )}

            {dataRequest?.vlPedido && (
              <Grid className={classeStyle.gridInfoOrderConfirmPayment}>
                <IconFidelidade0
                  className={classeStyle.gridInfoOrderConfirmIcon}
                />
                <Grid>
                  <h5 className={classeStyle.gridInfoOrderConfirmPaymentText}>
                    R${' '}
                    {FormatPrice(
                      parseFloat(dataRequest.vlPedido) +
                        parseFloat(dataRequest.vlEntrega),
                    )}
                  </h5>
                  <p className={classeStyle.gridInfoOrderConfirmTextP}>
                    O valor total do pedido
                  </p>
                </Grid>
              </Grid>
            )}
          </Grid>

          <Typography
            sx={{ mt: 2 }}
            className={classeStyle.textModalConfirmRequest}
          >
            Deseja enviar o pedido?
          </Typography>
        </Grid>

        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          marginTop="10px"
        >
          <Button
            className={classeStyle.btnModal}
            variant="contained"
            onClick={handleSendRequest}
          >
            {desNameBtnSend}
          </Button>
        </Grid>

        <Grid container item xs={12} justifyContent="center">
          <Button variant="text" onClick={onClose}>
            <p className={classeStyle.textBtnKeepShopping}>Alterar pedido</p>
          </Button>
        </Grid>
      </Box>
    </Modal>
  );
};
